const globalStyles = {
    dropdownWidth: (isTabletOrMobile) => ({
        width: isTabletOrMobile ? '100%' : 200
    })
}

export default globalStyles;